const LOGO = "https://customer-assets.emergentagent.com/job_d18eb75d-910a-420b-9f07-c4ad3b278ed1/artifacts/jkh8winw_BB%20Logo.png";

export default function Logo({ className = "h-16 w-16", showText = false }) {
  return (
    <div className="inline-flex items-center gap-3">
      <img
        src={LOGO}
        alt="الكتاب الأزرق"
        className={`${className} object-contain drop-shadow-[0_0_20px_rgba(197,160,89,0.25)]`}
        draggable={false}
      />
      {showText && (
        <span className="font-display font-black text-[#C5A059] text-lg tracking-wide">
          الكتاب الأزرق
        </span>
      )}
    </div>
  );
}
